module.exports = __webpack_public_path__ + "img/logo.c458987.png";